import React from "react";
import { IState } from "../../../../common/state/IState";
import { useSelector } from "react-redux";

const selector = (s: IState) =>
    s?.userManagement?.subscriptionPreferences?.error;

export function UmSpErrorContentComponent({ className }) {
    return <div className={className}>{useSelector(selector)}</div>;
}
